module.exports = __webpack_public_path__ + "static/media/SEE_ERROR_MESSAGE.efff90f5.svg";